export default __webpack_public_path__ + "static/media/21t.3824db67.jpg";